import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import { clamp } from 'utils/math';
import { getButtons } from 'components/editor/pages/landing/misc';
import { getReleaseMessaging } from 'utils/releaseMessaging';
import { getHubThundrData } from 'utils/thundr';

import SelectableSection from 'components/editor/selectableSection';
import Play from 'components/icons/playButton';
import Pause from 'components/icons/pauseButton';
import ArrowLeft from 'components/icons/arrowLeft';
import ArrowRight from 'components/icons/arrowRight';

import s from 'components/editor/pages/landing/hero/hero.sss';

export default class Hero extends Component {

	constructor(props) {
		super(props);
		this.state = {
			playing: true,
			selectedItem: this.getItems(props)[0],
			thundrData: {},
		};

		this.onTimeUpdate = this.onTimeUpdate.bind(this);
		this.setCurrentProgressElement = this.setCurrentProgressElement.bind(this);
		this.togglePlay = this.togglePlay.bind(this);
		this.selectItem = this.selectItem.bind(this);
		this.goToPrevious = this.goToPrevious.bind(this);
		this.goToNext = this.goToNext.bind(this);
	}

	getItems(props = this.props) {
		// return sortObjectByOrder(props.list);
		return props.list || [];
	}

	componentDidMount() {
		this.base.querySelector('video[autoplay]')?.play();
		this.loadThundrData();
	}

	async loadThundrData() {
		const thundrData = await getHubThundrData();
		this.setState({ thundrData });
	}

	componentWillUnmount() {
		this.observer?.disconnect();
	}

	componentWillReceiveProps(props) {
		if (props.activeElement !== this.props.activeElement && props.activeElement?.startsWith('/hero/list/')) {
			const index = props.activeElement.split('/')[3];
			const selectedItem = this.getItems(props)[index];
			if (selectedItem) {
				this.selectItem(selectedItem);
			}
		} else if (props.list !== this.props.list) {
			const newItems = this.getItems(props);
			const selectedItem = newItems.find(({ movie }) => movie === this.state.selectedItem?.movie) || newItems[0];
			this.selectItem(selectedItem);
		}
	}

	onTimeUpdate(e) {
		if (!e.target.parentElement) {
			// Has been removed from the DOM, ignore
			return;
		}
		this.updateProgress(e.target);
	}

	setCurrentProgressElement(e) {
		if (e) {
			this.$currentProgress = e;
		} else {
			this.progress = 0;
		}
	}

	updateProgress(video = this.base.querySelector('video')) {
		if (!video || !this.$currentProgress) return;
		let progress = video.currentTime / video.duration;
		this.$currentProgress.classList.remove(s.animate);
		this.$currentProgress.style.setProperty('--progress', progress);
		if (!video.paused) {
			let remaining = video.duration - video.currentTime;
			this.$currentProgress.offsetWidth;
			this.$currentProgress.style.setProperty('--remaining', remaining);
			this.$currentProgress.classList.add(s.animate);
		}
	}

	pause() {
		this.base.querySelector('video')?.pause();
		this.setState({ playing: false });
	}

	play() {
		this.base.querySelector('video')?.play();
		this.setState({ playing: true });
	}

	togglePlay() {
		if (this.state.playing) {
			this.pause();
		} else {
			this.play();
		}
	}

	selectItem(item) {
		if (item === this.state.selectedItem) return;

		this.setState({ selectedItem: item });

		if (!item) return;

		const items = this.getItems();
		const index = items.findIndex(e => item.movie === e.movie);
		if (index === -1) return;

		const $list = this.base.querySelector(`.${s.list}`);
		const $item = $list.children[index];

		if ($item) {
			let itemPosition = $item.offsetLeft;
			const newScroll = clamp($list.scrollLeft, itemPosition - $list.clientWidth + $item.clientWidth, itemPosition);
			// Can't use scrollIntoView as it causes the body to scroll (really tries to put the item in the viewport)
			//   see https://github.com/w3c/csswg-drafts/issues/9452
			$list.scrollTo({ left: newScroll, behavior: 'smooth' });
		}
	}

	goToPrevious() {
		const current = this.state.selectedItem?.movie;
		const items = this.getItems();
		const selectedIndex = items.findIndex(item => item.movie === current);
		const newIndex = selectedIndex === -1 ? -1 : (selectedIndex - 1) % items.length;
		this.selectItem(items.at(newIndex));
	}

	goToNext() {
		const current = this.state.selectedItem?.movie;
		const items = this.getItems();
		const selectedIndex = items.findIndex(item => item.movie === current);
		const newIndex = selectedIndex === -1 ? 0 : (selectedIndex + 1) % items.length;
		this.selectItem(items.at(newIndex));
	}

	getDateLabel(item = this.state.selectedItem) {
		const movie = this.props.movies?.[item?.movie];
		if (!movie) return '';
		
		if (movie.releaseMessagingOverride) {
			return movie.releaseMessagingOverride;
		}
		
		const status = movie.status || Store.get().movieStatuses?.[item?.movie];
		return getReleaseMessaging(movie, status, this.state.thundrData?.copy?.baseCopy);
	}

	renderCurrentButton() {
		const item = this.state.selectedItem;
		const movie = this.props.movies?.[item?.movie];
		if (!movie) return;
		const list = getButtons(movie, item);
		if (!list.length) return;

		const index = this.props.list.findIndex(e => e.movie === item?.movie);
		return (
			<SelectableSection section={`/hero/list/${index}`} activeElement={this.props.activeElement} class={s.buttons} noOutline key="buttons">
				{list.map(e => <div class={joinClasses(s.button, e.type === 'primary' && s.primary)}>{e.label}</div>)}
			</SelectableSection>
		);
	}

	render(props, state) {
		const selectedItem = state.selectedItem;
		const selectedMovie = props.movies?.[selectedItem?.movie];
		const movieTitle = selectedMovie?.title;
		const heroData = selectedMovie?.hero;
		const items = this.getItems(props);
		const showVideo = !!heroData?.desktop?.video?.url && heroData?.type !== 'image';

		return (
			<div class={s.wrapper}>
				<div class={s.media}>
					{showVideo && (
						<video
							class={s.preview}
							src={heroData.desktop.video.url}
							autoplay={this.state.playing}
							preload="auto"
							playsinline
							loop
							muted
							onTimeUpdate={this.onTimeUpdate}
							width="1920"
							height="800"
						/>
					)}

					{items.length === 0 && (
						<div class={s.message}>Please add a movie to view it in the hero carousel</div>
					)}

					<div class={joinClasses(s.videoPoster, (!state.playing || !showVideo) && s.show)}>
						{!!heroData?.desktop?.still?.url && <img src={heroData?.desktop?.still?.url} alt={heroData?.desktop?.still?.alt || `${movieTitle} poster image`} key={selectedMovie?.id || 'none'} />}
					</div>
					<div class={s.controls}>
						<div class={s.nav}>
							<div class={s.buttons}>
								<button class={joinClasses(s.prev, selectedItem?.order === 0 && s.inactive)} onClick={this.goToPrevious} data-section="#"><ArrowLeft /></button>
								<button class={joinClasses(s.next, selectedItem?.order === items.length - 1 && s.inactive)} onClick={this.goToNext} data-section="#"><ArrowRight /></button>
							</div>
							<div class={s.list}>
								{items.map((item, i) => {
									const movie = props.movies?.[item?.movie];
									if (!movie) return null;
									const current = selectedMovie?.id === movie.id;
									let progressProps = !current ? {} : {
										ref: this.setCurrentProgressElement,
										// onAnimationEnd: this.onProgressAnimationEnd,
									};
									return (
										<SelectableSection section={`/hero/list/${i}`} activeElement={props.activeElement} class={joinClasses(s.item, current && s.active)} key={movie.id || i}>
											<div class={s.title}>{movie.title}</div>
											<div class={s.date}>{this.getDateLabel(item)}</div>
											<div class={joinClasses(s.progress, !state.playing && s.paused, !movie?.hero?.desktop?.video && s.static)} {...progressProps} />
										</SelectableSection>
									);
								})}
							</div>
						</div>
						<button class={s.playPause} onClick={this.togglePlay} data-section="#">{state.playing ? <Pause height="14" /> : <Play height="14" />}</button>
					</div>
				</div>
				{/* <SelectableSection section={`/hero/list/${state.selectedItem?.movie?.id}`} activeElement={this.props.activeElement} class={s.details}> */}
				<div class={s.details}>
					<div class={s.info} key="info">{this.getDateLabel()}</div>
					<h2 class={s.title} key="title">{movieTitle}</h2>
					{this.renderCurrentButton()}
				</div>
				{/* </SelectableSection> */}
			</div>
		);
	}
}